import { APP_SWITCHER_TARGET_ID, NAV_DOM_ID } from '../constants';
import { getAlchemyStaticStyles } from './get-alchemy-static-styles';
import { getGlobalStyle } from './get-global-style';
export const injectAppSwitcherCss = (options) => {
    const styleTag = document.createElement('style');
    const targetId = options.targetId || APP_SWITCHER_TARGET_ID;
    styleTag.textContent = `
        ${getGlobalStyle(options)}
        ${getAlchemyStaticStyles(options, `#${NAV_DOM_ID}_${targetId}`)}
    `;
    const head = document.querySelector('head');
    if (head && head.appendChild) {
        head.appendChild(styleTag);
    }
};
